export default __webpack_public_path__ + "static/media/AWAYAM-dark.19bac87c.svg";